export const isSignatureReady = (method: 'otp' | 'ca' | 'click', otp: string, accepted: boolean): boolean =>
  accepted && (method !== 'otp' || /^\d{6}$/.test(otp))
